import { render } from "./primary-image-schema.vue?vue&type=template&id=72907f66"
import script from "./primary-image-schema.vue?vue&type=script&lang=js"
export * from "./primary-image-schema.vue?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__